import { PaymentFormula, Total } from '../../types';

const getTrialValue = (firstPayment: number, secondPayment: number): number => {
  return Math.round(firstPayment * 0.88 + secondPayment * 1.77 - 0.62) / 100;
};

const getSubscriptionValue = (
  firstPayment: number,
  secondPayment: number,
): number => {
  return Math.round(firstPayment * 0.88 + secondPayment * 1.27 - 0.36) / 100;
};

const getOneTimeValue = (firstPayment: number): number => {
  return (firstPayment * 0.86) / 100;
};

const getPriceValue = (total: Total): number => {
  const { firstPayment, secondPayment, formula } = total;

  switch (formula) {
    case PaymentFormula.SUBSCRIPTION:
      return getSubscriptionValue(firstPayment, secondPayment);

    case PaymentFormula.TRIAL:
      return getTrialValue(firstPayment, secondPayment);

    case PaymentFormula.ONETIME:
      return getOneTimeValue(firstPayment);

    default:
      return getOneTimeValue(firstPayment);
  }
};

export default getPriceValue;
